export default __webpack_public_path__ + "static/media/BUYING 3.7e72827f.png";